const { qrcodeValueModes } = require('@transfeeradev/api-enums/pix');
const { qrcodeValueModes: bcbValueModes } = require('@transfeeradev/api-enums/pix/bcb');

class PixQRCodeConverter {
  constructor({ fromValueModes, toValueModes } = {}) {
    this._fromValueModes = fromValueModes || qrcodeValueModes;
    this._toValueModes = toValueModes || bcbValueModes;
  }

  convertValueChangeMode(mode) {
    const VALUE_CHANGE_MODES = {
      [this._fromValueModes.VALUE_CHANGE_MODE.FIXED_VALUE]: this._toValueModes.VALUE_CHANGE_MODE.FIXED_VALUE,
      [this._fromValueModes.VALUE_CHANGE_MODE.MODIFIABLE]: this._toValueModes.VALUE_CHANGE_MODE.MODIFIABLE
    };
    return VALUE_CHANGE_MODES[mode];
  }

  convertDiscountMode(mode) {
    const DISCOUNT_MODES = {
      [this._fromValueModes.DISCOUNT_MODES.FIXED_VALUE_UNTIL_THE_DATES_INFORMED]:
        this._toValueModes.DISCOUNT_MODES.FIXED_VALUE_UNTIL_THE_DATES_INFORMED,
      [this._fromValueModes.DISCOUNT_MODES.PERCENTAGE_DATE_REPORTED]:
        this._toValueModes.DISCOUNT_MODES.PERCENTAGE_DATE_REPORTED,
      [this._fromValueModes.DISCOUNT_MODES.AMOUNT_PER_CALENDAR_DAY_ADVANCE]:
        this._toValueModes.DISCOUNT_MODES.AMOUNT_PER_CALENDAR_DAY_ADVANCE,
      [this._fromValueModes.DISCOUNT_MODES.AMOUNT_ADVANCE_BUSINESS_DAY]:
        this._toValueModes.DISCOUNT_MODES.AMOUNT_ADVANCE_BUSINESS_DAY,
      [this._fromValueModes.DISCOUNT_MODES.PERCENTAGE_ADVANCE_CURRENT_DAY]:
        this._toValueModes.DISCOUNT_MODES.PERCENTAGE_ADVANCE_CURRENT_DAY,
      [this._fromValueModes.DISCOUNT_MODES.PERCENTAGE_ADVANCE_BUSINESS_DAY]:
        this._toValueModes.DISCOUNT_MODES.PERCENTAGE_ADVANCE_BUSINESS_DAY
    };
    return DISCOUNT_MODES[mode];
  }

  convertAbatementMode(mode) {
    const ABATEMENT_MODES = {
      [this._fromValueModes.ABATEMENT_MODES.FIXED_VALUE]: this._toValueModes.ABATEMENT_MODES.FIXED_VALUE,
      [this._fromValueModes.ABATEMENT_MODES.PERCENT]: this._toValueModes.ABATEMENT_MODES.PERCENT
    };
    return ABATEMENT_MODES[mode];
  }

  convertFineMode(mode) {
    const FINE_MODES = {
      [this._fromValueModes.FINE_MODES.FIXED_VALUE]: this._toValueModes.FINE_MODES.FIXED_VALUE,
      [this._fromValueModes.FINE_MODES.PERCENT]: this._toValueModes.FINE_MODES.PERCENT
    };
    return FINE_MODES[mode];
  }

  convertInterestMode(mode) {
    const INTEREST_MODES = {
      [this._fromValueModes.INTEREST_MODES.VALUE_CALENDAR_DAYS]: this._toValueModes.INTEREST_MODES.VALUE_CALENDAR_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_DAY_CALENDAR_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_DAY_CALENDAR_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_MONTH_CALENDAR_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_MONTH_CALENDAR_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_YEAR_CALENDAR_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_YEAR_CALENDAR_DAYS,
      [this._fromValueModes.INTEREST_MODES.VALUE_WORKING_DAYS]: this._toValueModes.INTEREST_MODES.VALUE_WORKING_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_DAY_WORKING_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_DAY_WORKING_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_MONTH_WORKING_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_MONTH_WORKING_DAYS,
      [this._fromValueModes.INTEREST_MODES.PERCENTAGE_PER_YEAR_WORKING_DAYS]:
        this._toValueModes.INTEREST_MODES.PERCENTAGE_PER_YEAR_WORKING_DAYS
    };
    return INTEREST_MODES[mode];
  }
}

module.exports = PixQRCodeConverter;
